import React from 'react';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { OutsourceListCard } from '../../my-outsources/outsource/list/OutsourceListCard';

export class MyOutsourcesViewerDashboard extends React.Component {

    render() {
        const { breadcrumbs } = this.props;
        const title = `${I18nUtils.tr('TR_INICIO')} - ${I18nUtils.tr('TR_MIS_SUBCONTRATAS')}`;

        return (
            <PsPage title={title} breadcrumbs={breadcrumbs}>
                <OutsourceListCard/>
            </PsPage>
        );
    }
}

MyOutsourcesViewerDashboard.propTypes = {};

MyOutsourcesViewerDashboard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboards/MyOutsourcesViewerDashboard.jsx